import logoTransparent from "@/assets/logo-transparent.webp";
import logoNavy from "@/assets/logo-navy.webp";
import logoWhite from "@/assets/logo-white.webp";
import logoBw from "@/assets/logo-bw.webp";

/**
 * Emad brand mark.
 *
 * The asset already embeds:
 *   - Arabic wordmark «عماد»
 *   - Latin wordmark «EMAD»
 *   - Tagline «لتأهيل وتمكين القيادات»
 * Therefore `showText` defaults to false to avoid duplication with the embedded text.
 *
 * Variant selects the correct color palette for the surface it sits on:
 *   - navy / bw  → dark glyphs, for LIGHT surfaces (sidebar, cards)
 *   - white / transparent / cream → light glyphs, for DARK surfaces (hero, nav overlay)
 */
const LOGO_BY_VARIANT = {
  navy: logoNavy,
  bw: logoBw,
  white: logoWhite,
  transparent: logoTransparent,
  cream: logoTransparent,
};

export default function Logo({
  variant = "navy",
  size = 88,
  showText = false,
  textColor = "text-slate-900",
  subColor = "text-slate-500",
  className = "",
}) {
  const src = LOGO_BY_VARIANT[variant] || logoNavy;
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      {/* Preload the alternate variants once so scroll-triggered swap is instant */}
      <link rel="preload" as="image" href={logoNavy} />
      <link rel="preload" as="image" href={logoTransparent} />
      <img
        src={src}
        alt="Emad Logo"
        style={{ height: size, width: "auto", maxWidth: size * 1.2 }}
        className="object-contain shrink-0 select-none pointer-events-none"
        draggable={false}
        decoding="sync"
        fetchPriority="high"
        data-testid="brand-logo"
      />
      {showText && (
        <div className="min-w-0">
          <div
            className={`font-heading font-black leading-none ${textColor}`}
            style={{ fontSize: size >= 64 ? "1.35rem" : size >= 44 ? "1.15rem" : "1.05rem" }}
          >
            عماد
          </div>
          <div className={`text-xs mt-1 ${subColor}`}>لتأهيل وتمكين القيادات الشابة</div>
        </div>
      )}
    </div>
  );
}
